import { Box, Typography } from '@mui/material';
import i18n from 'i18next';
import { getAssetsUrl } from '../../utils/@helper/file.helper';

const NoData = ({ primary = i18n?.t('cgam.no.data'), secondary, minHeight= 'auto' }) => {
  return (
    <Box
      position={'relative'}
      mx={'auto'}
      textAlign={'center'}
      minHeight={minHeight}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Box
        pt={2}
        mx={'auto'}
        width={96}
        component={'img'}
        src={getAssetsUrl('images/img-empty.gif')}
      />
      <Typography variant='h6' mt={2} mb={1} textAlign={'center'}>
        { primary }
      </Typography>
      {
        secondary && (
          <Typography variant='body2' color={'text.secondary'} textAlign={'center'}>
            { secondary }
          </Typography>
        )
      }
    </Box>
  )
};

export default NoData;
